__turbopack_context__.v({
  "details": "styles-module-scss-module__6hFugG__details",
  "listing_courtesy_of": "styles-module-scss-module__6hFugG__listing_courtesy_of",
  "section_header": "styles-module-scss-module__6hFugG__section_header",
  "visitor_stats": "styles-module-scss-module__6hFugG__visitor_stats",
});
